(function ($, Drupal, drupalSettings, once) {

  Drupal.behaviors.vscLayoutTabs = {

    attach: function (context, settings) {

      once('vscLayoutTabs', '.vsc-tabs', context).forEach(function (element, index) {

        // Get tab buttons and panes elements
        let vscTabButtons = element.querySelectorAll('.vsc-tab-button');
        let vscTabButtonsMobile = element.querySelectorAll('.vsc-tab-button-mobile');
        let $vscTabPanesContainer = $(element).find('.vsc-tabs-panes');
        let $vscTabPanes = $(element).find('.vsc-tabs-pane');


        // On page load - Close all tabs and open the first tab

        // Hide all tab pane elements
        $vscTabPanes.hide();

        // Add selected class modifier to first TabButton and first TabButtonMobile
        vscTabButtons[0].classList.add('selected');
        vscTabButtonsMobile[0].classList.add('selected');

        // Show first tab pane element
        $vscTabPanes.first().show();



        // Toggle tab pane display when a tab button is clicked - Desktop
        vscTabButtons.forEach(function(vscTabButtonItem) {

          vscTabButtonItem.addEventListener('click', function (event) {
            event.preventDefault();

            // Get related tab ID from TabButton href
            let tabIDToOpen = $(this).find('a').attr('href');

            // Get related tab button mobile element
            let relatedTabButtonMobile = element.querySelector('.vsc-tab-button-mobile a[href="' + tabIDToOpen + '"').parentElement;

            // Get related tab pane element
            let $tabToOpen = $vscTabPanesContainer.find(tabIDToOpen);

            if (!this.classList.contains('selected')) {

              // Clear all selected class modifiers from TabButtons
              vscTabButtons.forEach(function (vscTabButtonItem) {
                vscTabButtonItem.classList.remove('selected');
              });

              // Clear all selected class modifiers from TabButtonsMobile
              vscTabButtonsMobile.forEach(function (vscTabButtonMobileItem) {
                vscTabButtonMobileItem.classList.remove('selected');
              });

              // Hide all tab pane elements
              $vscTabPanes.hide();

              // Add selected class modifier to clicked TabButton
              this.classList.add('selected');

              // Add selected class modifier to related TabButtonMobile
              relatedTabButtonMobile.classList.add('selected');

              // Show related tab pane element
              $tabToOpen.show();
            }
          });
        });



        // Toggle tab pane display when a tab button mobile is clicked - Mobile
        vscTabButtonsMobile.forEach(function(vscTabButtonMobileItem) {

          vscTabButtonMobileItem.addEventListener('click', function (event) {
            event.preventDefault();
            let clickedButton = this;

            // Get related tab ID from TabButton href
            let tabIDToOpen = $(this).find('a').attr('href');

            // Get related tab button mobile element
            let relatedTabButton = element.querySelector('.vsc-tab-button a[href="' + tabIDToOpen + '"').parentElement;

            // Get related tab pane element
            let $tabToOpen = $vscTabPanesContainer.find(tabIDToOpen);

            if (!this.classList.contains('selected')) {

              // Clear all selected class modifiers from TabButtonsMobile
              vscTabButtonsMobile.forEach(function (vscTabButtonMobileItem) {
                vscTabButtonMobileItem.classList.remove('selected');
              });

              // Clear all selected class modifiers from TabButtons
              vscTabButtons.forEach(function (vscTabButtonItem) {
                vscTabButtonItem.classList.remove('selected');
              });

              // Slide Up all tab pane elements
              $vscTabPanes.slideUp();

              // Add selected class modifier to clicked TabButtonMobile
              this.classList.add('selected');

              // Add selected class modifier to related TabButton
              relatedTabButton.classList.add('selected');

              // Slide Down related tab pane element
              $tabToOpen.slideDown(function() {

                // Set pixel offset from top of page , 0 will be page top
                let offset = 0;

                const navbarContentOffset = parseFloat(window.getComputedStyle(document.documentElement).getPropertyValue('--navbar-content-offset').trim());
                const tabsPanesGap = parseFloat(window.getComputedStyle(document.documentElement).getPropertyValue('--vsc-tabs-panes-gap').trim());
                
                if (navbarContentOffset) {
                  offset = navbarContentOffset;
                }

                if (tabsPanesGap) {
                  offset += tabsPanesGap;
                }

                // Set the scroll target offset
                const scrollTarget = $(clickedButton).offset().top - offset;

                $('html').animate({
                  scrollTop: (scrollTarget)
                }, 400); // 400 is the default slideDown speed
              });
            } else {

              // Clear all selected class modifiers from TabButtonsMobile
              vscTabButtonsMobile.forEach(function (vscTabButtonMobileItem) {
                vscTabButtonMobileItem.classList.remove('selected');
              });

              // Clear all selected class modifiers from TabButtons
              vscTabButtons.forEach(function (vscTabButtonItem) {
                vscTabButtonItem.classList.remove('selected');
              });

              // Slide Up all tab pane elements
              $vscTabPanes.slideUp();
            }
          });
        });

      });

    }
  };
}(jQuery, Drupal, drupalSettings, once));
